import React from 'react';
import { InputLabelProps } from '@mui/material/InputLabel';
import { StyledInputLabel } from './input-label.style';

export const InputLabel = ({ children, ...props }: InputLabelProps) => {
    return (
        <StyledInputLabel shrink {...props}>
            {children}
        </StyledInputLabel>
    );
};
